<script>
    import { mapActions } from 'vuex';
    import { capitalize } from '@shared/filters';
    import { routeNames } from '@app/router';

    const BACK_ID = 'back';

    export default {
        name: 'SidebarContainer',
        created() {
            this.items = [
                {
                    id: BACK_ID,
                    name: capitalize(this.$t('back')),
                    icon: 'icon-chevron_left',
                },
                {
                    id: routeNames.profile,
                    name: capitalize(this.$t('my account')),
                    icon: 'icon-user',
                },
                {
                    id: routeNames.tickets,
                    name: capitalize(this.$t('my tickets')),
                    icon: 'icon-ticket_2',
                },
                {
                    id: routeNames.deposit,
                    name: capitalize(this.$t('deposit')),
                    icon: 'icon-deposit',
                },
                {
                    id: routeNames.withdrawal,
                    name: capitalize(this.$t('withdrawal')),
                    icon: 'icon-withdrawal',
                },
                {
                    id: routeNames.history,
                    name: capitalize(this.$t('history')),
                    icon: 'icon-transactions',
                },
                {
                    id: routeNames.settings,
                    name: capitalize(this.$t('settings')),
                    icon: 'icon-settings',
                },
                {
                    id: routeNames.documentUpload,
                    name: capitalize(this.$t('document upload')),
                    icon: 'icon-upload_2',
                }
            ];
        },
        methods: {
            ...mapActions('navigation', [
                'replace',
            ]),
            onItemClick(items) {
                if (items[0].id === BACK_ID) {
                    this.$router.push({ name: routeNames.landing });
                } else {
                    this.$router.push({ name: items[0].id });
                }
            },
        },
        computed: {
            activeItem() {
                const routeName = this.$route.name;
                return this.items.find((item) => (item.id === routeName));
            }
        },
        render() {
            return this.$scopedSlots.default({
                items: this.items,
                activeItem: this.activeItem,
                onItemClick: (item) => {
                    this.onItemClick(item);
                }
            });
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Account/AccountSidebarContainer.vue